import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import logoImg from '../assets/blast-logo.webp';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3301/api';

export default function AllGallery() {
  const [albums, setAlbums] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/gallery/`)
      .then((res) => setAlbums(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} />
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>
      </nav>
      <div style={{ padding: '0 6vw 60px', maxWidth: 1000, margin: '0 auto' }}>
        <span style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 3, textTransform: 'uppercase' }}>
          Galeri
        </span>
        <h1 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 30px' }}>
          Semua Galeri
        </h1>
        {loading ? (
          <p style={{ color: '#8B92A0' }}>Memuat...</p>
        ) : albums.length === 0 ? (
          <p style={{ color: '#8B92A0' }}>Belum ada galeri.</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16 }}>
            {albums.map((a) => (
              <Link
                key={a.id}
                to={`/gallery/${a.id}`}
                style={{
                  background: '#1C2128', border: '1px solid #262b33', padding: 16,
                  textDecoration: 'none', color: 'inherit', display: 'block',
                  clipPath: 'polygon(0 0, 100% 0, 100% 90%, 90% 100%, 0 100%)',
                }}
              >
                <p style={{ fontWeight: 800, fontSize: 14 }}>{a.event_title}</p>
                <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                  {new Date(a.tanggal_mulai).toLocaleDateString('id-ID')}
                </p>
                <p style={{ color: '#2B6996', fontSize: 12, marginTop: 8, fontWeight: 700 }}>
                  📷 {a.total_foto} foto
                </p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
